import { render } from "./AppSelect.vue?vue&type=template&id=669da55a&scoped=true&ts=true"
import script from "./AppSelect.vue?vue&type=script&lang=ts"
export * from "./AppSelect.vue?vue&type=script&lang=ts"

import "./AppSelect.vue?vue&type=style&index=0&id=669da55a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669da55a"]])

export default __exports__